import { services } from '../services';
var action = "property/latepayment/";
/* eslint-disable no-console */
export const propertylatepaymentService = {
    getList,
    getOne,
    insert,
    byProperty
};

function getList(property_id) {
    return services.restApi(`${action}index?property_id=${property_id}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}show/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}generate`, 'POST', object);
}

function byProperty(object) {

    console.log(JSON.stringify(object));
    return services.restApi(`properties/paylate`, 'POST', object);
}